export default {
  title: {
    id: 'product_page_deal_tag_title',
    defaultMessage: 'Deals available',
  },
  description: {
    id: 'product_page_deal_tag_description',
    defaultMessage: 'See limited deals and price drops',
  },
} as const
